import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { CampusUnitMessage } from '../../models/notifications/campus-unit-message.model';
import { catchError, retry } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class CampusUnitsMessageService {
    private baseUrl = 'api/campus-units-messages';

    constructor(private httpClient: HttpClient) { }

    /**
     * Gets all messages
     */
    getAllMessages() {
        return this.httpClient.get<CampusUnitMessage[]>(`${this.baseUrl}`)            
            .pipe(
                retry(2),
                catchError(this.handleBadRequest('Unable to get messages'))
            );
    }

    /**
     * Returns a message with the specified id if found
     * @param messageId id
     */
    getMessage(messageId: number) {
        return this.httpClient.get<CampusUnitMessage>(`${this.baseUrl}/${messageId}`)
        .pipe(
            retry(2)
        );
    }

    /**
     * Returns all active messages
     */
    getActiveMessages() {
        return this.httpClient.get<CampusUnitMessage[]>(`${this.baseUrl}/active`);
    }

    /**
     * Create a new campus message
     */
    createMessage(newMessage: CampusUnitMessage) {
        return this.httpClient.post<CampusUnitMessage>(`${this.baseUrl}/new`, newMessage)
            .pipe(catchError(this.handleBadRequest('Unable to create new message')));
    }

    /**
     * Update message
     * @param messageId id
     * @param updatedMessage new message
     */
    updateMessage(messageId: number, updatedMessage: CampusUnitMessage) {
        return this.httpClient.put<CampusUnitMessage>(`${this.baseUrl}/${messageId}`, updatedMessage)
            .pipe(catchError(this.handleBadRequest('Unable to update message')));
    }


    handleBadRequest(genericMessage: string = 'An error occurred') {
        return (error: HttpErrorResponse) => {
            if (error.status >= 400 && error.status < 500 && typeof error.error === 'string') {
                return throwError(error.error);
            }
            return throwError(genericMessage);
        };
    }

}
